import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SatisfactionsMiscApiService } from '../api/satisfactions-misc-api.service';
import { Satisfaction, DomainSatisfaction } from './models/satisfaction';

@Injectable({
    providedIn: 'root'
})
export class SatisfactionsMiscDomainService
{

    constructor (
        private satisfactionsApiService: SatisfactionsMiscApiService
    )
    { }

    getUserEntitySatisfactions (): Observable<Satisfaction[]>
    {
        return this.satisfactionsApiService.getUserEntitySatisfactions()
            .pipe(
                map(satisfactionsApi =>
                    satisfactionsApi.map(c => DomainSatisfaction.mapperFromApi(c))
                )
            );
    }

    getAllSatisfactions (): Observable<Satisfaction[]>
    {
        return this.satisfactionsApiService.getAllSatisfactions()
            .pipe(
                map(satisfactionsApi =>
                    satisfactionsApi.map(c => DomainSatisfaction.mapperFromApi(c))
                )
            );
    }
}
